import {RouletteEntryTypeVo} from '../../common/shared/api/nicolas/vo/enums/RouletteEntryTypeVo.enum';
import {RouletteEntryType} from '../generated/types';

export function createRouletteEntryType(entry_type: RouletteEntryTypeVo) {
  return ROULETTE_ENTRY_TYPE_MAP[entry_type];
}

const ROULETTE_ENTRY_TYPE_MAP = {
  [RouletteEntryTypeVo.None]: RouletteEntryType.None,
  [RouletteEntryTypeVo.CashSponsorAd]: RouletteEntryType.CashSponsorAd,
  [RouletteEntryTypeVo.Redeem]: RouletteEntryType.Redeem,
  [RouletteEntryTypeVo.Direct]: RouletteEntryType.Direct,
  [RouletteEntryTypeVo.DirectV2]: RouletteEntryType.DirectV2,
  [RouletteEntryTypeVo.RedeemV2]: RouletteEntryType.RedeemV2,
};
